
<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Device Master</h5>
            </div>
            <div class="basic-contbox">
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Device Name</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Device Name" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Device ID</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Device ID" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Device IP</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Device IP" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Port Name</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Port Name" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Device Password</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Device Password" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Device Type</h5>
                    </div>
                    <div class="emp-input">
                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a Device" [(ngModel)]="selectedValue">
                            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
                            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
                            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
                          </nz-select>
                    </div>
                </div>

                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void();"><span></span> Edit</a></li>
                        <li><a href="javascript:void();"><span></span> Save</a></li>
                        <li><a href="javascript:void();"><span></span> Clear</a></li>
                        <li><a href="javascript:void();"><span></span>Close</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="basic-details basic-details3">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Device Name</th>
                            <th>Device ID</th>
                            <th>Device IP</th>
                            <th>Port</th>
                            <th>Device type code</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.age }}</td>
                            <td>{{ data.name }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td><span><i nz-icon nzType="delete" nzTheme="fill"></i></span></td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>